<div class="canales_de_contacto">
  <div class="titulo_canales" *ngIf="titulo.length > 0">
    <p class="texto_titulo_canales">{{ titulo }}</p>
  </div>
  <div class="listado_canales">
    <a
      (click)="ir_a_tramite_click($event)"
      class="a_enlace_tramite"
      *ngIf="ir_a_tramite"
    >
      <div class="icono_tramite">
        <img
          src="assets/images/vectors83641664.svg"
          width="12px"
          height="16px"
          class="vector_vector"
        />
      </div>
      <p class="texto_enlace_tramite">Ir al trámite</p>
    </a>
    <a
      (click)="enviar_consulta_click($event)"
      *ngIf="enviar_consulta"
      class="a_enlace_consultenos"
    >
      <div class="icono_consultenos">
        <img
          src="assets/images/vectors83641704.svg"
          width="15.36669921875px"
          height="11.366577148438px"
          class="vector_vector_1"
        />
      </div>
      <p class="texto_enlace_consultenos">Enviar una consulta</p>
      <app-icono-candado *ngIf="requiereAutenticacion"></app-icono-candado>
    </a>
    <a
      class="a_enlace_messenger"
      (click)="messenger_click($event)"
      *ngIf="messenger"
    >
      <div class="icono_messenger">
        <img
          src="assets/images/vectors83641713.svg"
          width="16.366748046875px"
          height="15.566625976562px"
          class="vector_vector_2"
        />
      </div>
      <p class="texto_enlace_messenger">Chatear por Facebook/Messenger</p>
    </a>
  </div>
</div>
